module.exports = __webpack_public_path__ + "static/media/lb-rotu.38c23825.svg";